/**
 * @description type guard function that validates that the given redirectUrl is an allowed domain
 * Currently this should only be used for absolute URLs from the Alta
 * @returns boolean
 */
export const isValidAbsoluteRedirectUrl = (
  redirectUrl?: string,
): redirectUrl is string => {
  const re = /(http|https):\/\/*.*\.(alta.avigilon.com|avasecurity.com|ava.uk)/;
  const local = /(http):\/\/(localhost:3000)/;
  return Boolean(
    redirectUrl && (re.test(redirectUrl) || local.test(redirectUrl)),
  );
};
